export function enumFromStringValue<T>(
  enm: { [s: string]: T },
  value: string | undefined | null,
): T | undefined {
  if (!value) {
    return undefined;
  }
  return (Object.values(enm) as unknown as string[]).includes(value)
    ? (value as unknown as T)
    : undefined;
}
